import React from "react";
import { FiEye } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function ViewActionButton({ onClick, to, label = "View details", className = "", disabled = false }) {
  const classes = `inline-flex h-8 w-8 items-center justify-center rounded-lg text-[#1234CD] transition-colors hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-[#1234CD]/40 disabled:cursor-wait disabled:opacity-50 ${className}`;
  const content = <FiEye className="h-[18px] w-[18px]" aria-hidden="true" />;

  return to ? (
    <Link to={to} className={classes} aria-label={label} title={label}>
      {content}
    </Link>
  ) : (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={classes}
      aria-label={label}
      title={label}
    >
      {content}
    </button>
  );
}
